/* globals Store */
import api from './backend-api'
/* eslint-disable */


export default {
    login(data, cb) {
        cb = arguments[arguments.length - 1]
        let Data={
            platform:'web',
            device_token:localStorage.getItem('device_token')
        }
        api.login('auth/login', data).then((res) => {
            const token = res.data.token
            const user = res.data.user
            Store.dispatch('updateUser', { user, token })
            Store.state.SidebarStatus=true;
            if (cb) cb(true, null)
            this.onChange(true)
            api.postData('auth/saveDevice',Data)
            .then(res=>{
                console.log("Device token sent to server")
            })
        }, (err) => {
            if (cb) cb(false, err)
            this.onChange(false)
        })
    },
        
    getToken() {
        return Store.state.token
    },
    logout(cb) {
        // delete localStorage.token
        // Store.commit('setToken', null)
        Store.state.SidebarStatus=false;
        Store.dispatch('logout')
        if (cb) cb(false)
        this.onChange(false)
    },
    loggedIn() {
      return Store.state.token
    },
    onChange() {}
}



// WEBPACK FOOTER //
// ./src/utils/auth.js